module.exports = __webpack_public_path__ + "static/media/ctv_streamingapp_video.039e2339.png";